import { render, staticRenderFns } from "./Biometric.vue?vue&type=template&id=3288c4c1&"
import script from "./Biometric.vue?vue&type=script&lang=ts&"
export * from "./Biometric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports